module.exports = __webpack_public_path__ + "static/media/c4.befd3937.png";